import request from "@/utils/request";
// 问答
export function getList(where) {
    return request.get("/business/bQa", where);
}

export function getQaList(where) {
    return request.get("/business/bQa", where, {
        login: false
    });
}

export function add(where) {
    return request.post("/business/bQa", where);
}

export function getInfo(id) {
    return request.get("/business/bQa/" + id);
}

export function getAnno(id) {
    return request.get("/business/bQa/queryConfig", id);
}
